import { getCurrentInstance } from 'vue';

const getGlobalProperties = (): any => {
  const instance = getCurrentInstance();
  return instance?.appContext.config.globalProperties || {};
};
export {
  getGlobalProperties,
};
